package com.evoapps.evoshift.util

import androidx.compose.runtime.Composable

/** SH-180: no system screenshot to keep out of here; the Android and iOS actuals do the work. */
@Composable
actual fun SecureScreenEffect(secure: Boolean) = Unit
